import {
  CardActionArea,
  CardActions,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Box } from "@mui/system";
import * as React from "react";
import { Link } from "react-router-dom";
import Footer from "../../../Shared/Footer/Footer";
import Header from "../../../Shared/Header/Header";
import BlogsData from "./BlogsData";

const Blogs = () => {
  return (
    <div>
      <div
        style={{
          background:
            "linear-gradient(45deg, rgb(45, 54, 76) 0%, rgb(37, 45, 63) 100%)",
        }}
      >
        <Header />
        <Container>
          <Box>
            <Typography
              className="section-title"
              sx={{ color: "whitesmoke", mb: 10 }}
              variant="h3"
            >
              Portfolio
            </Typography>
          </Box>
          <Box sx={{ my: 5 }}>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              {BlogsData.map((data) => (
                <Grid item xs={12} sm={12} md={4} key={data.id}>
                  <Card sx={{ maxWidth: 345 }}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        height="240"
                        image={data.img}
                        alt="green iguana"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h6" component="div">
                          {data.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {data.description.slice(0, 100)}...
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <Link
                        style={{
                          color: "black",
                          textDecoration: "none",
                          marginLeft: "10px",
                        }}
                        to="https://medium.com/@ishan0563/10-things-i-learn-about-javascript-c7205e24055c"
                      >
                        Details
                      </Link>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
        <Footer />
      </div>
    </div>
  );
};

export default Blogs;
